/**
 * SelectionToolbar — Sprint 4.1.2.
 *
 * Barra acima do mapa com:
 *   - Botões de modo (Retângulo / Círculo / Lasso)
 *   - Hint de atalhos
 *   - Indicador do modo ativo + ESC para cancelar
 *
 * O componente é apresentacional. Estado do modo vem de useMapSelection
 * via prop. As ações chamam startMode/cancelMode.
 */

const MODES = [
  { id: "rectangle", label: "▭ Retângulo", hint: "SHIFT + arrastar" },
  { id: "circle",    label: "◯ Círculo",   hint: "ALT + arrastar" },
  { id: "lasso",     label: "✎ Lasso",     hint: "L · cliques · dblclick fecha" },
];

export default function SelectionToolbar({
  mode,            // 'idle' | 'rectangle' | 'circle' | 'lasso'
  startMode,
  cancelMode,
  previewCount,    // {count, mode, drawing} ou null
}) {
  return (
    <div className="bg-noc-panel border border-noc-border rounded p-2 flex items-center gap-2 text-xs flex-wrap">
      <span className="text-noc-muted">Seleção:</span>
      {MODES.map((m) => {
        const active = mode === m.id;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => startMode(m.id)}
            title={`${m.label} — ${m.hint}`}
            className={`px-2 py-1 rounded border text-[11px] ${
              active
                ? "border-noc-accent/30 bg-noc-accent/10 text-noc-accent"
                : "border-noc-border text-noc-muted hover:text-noc-text hover:border-noc-accent/30"
            }`}
          >
            {m.label}
          </button>
        );
      })}

      {mode !== "idle" && (
        <>
          <span className="text-noc-accent px-2 py-0.5 bg-noc-accent/10 rounded text-[10px] animate-pulse">
            ● desenhando: {mode}
          </span>
          <button
            type="button"
            onClick={cancelMode}
            className="text-[10px] px-2 py-0.5 rounded border border-noc-err/30 text-noc-err hover:border-noc-err/30"
          >
            ESC · cancelar
          </button>
        </>
      )}

      {previewCount?.drawing && (
        <span className="text-noc-accent text-[10px]">
          {previewCount.count} dentro da área
        </span>
      )}

      <span className="flex-1" />
      <span className="text-[10px] text-noc-muted/60">
        💡 Ctrl/⌘+click: multi · L: lasso · SHIFT+arrastar: retângulo · ALT+arrastar: círculo · ESC: cancelar
      </span>
    </div>
  );
}
